import React from 'react';

import { DEFAULT_MARKET } from 'utils/market/market';
import { DEFAULT_LOCALE } from 'utils/i18n/localeConfig';

export interface MarketType {
  marketCode: string;
  locale: string;
  dir: 'ltr' | 'rtl';
  // Since we don't support all langauges, this is not always the same as "dir"
  // example: masthead sometimes will be different from the site
  preferredDir: 'ltr' | 'rtl';
}

interface MarketContextProps {
  market: MarketType;
  children: React.ReactNode;
}

export const MarketContext = React.createContext<MarketType>({
  marketCode: DEFAULT_MARKET,
  locale: DEFAULT_LOCALE,
  dir: 'ltr',
  preferredDir: 'ltr',
});

const MarketProvider = ({ market, children }: MarketContextProps) => {
  return <MarketContext.Provider value={market}>{children}</MarketContext.Provider>;
};

export default MarketProvider;
